/**
 * AccountActions
 *
 * Toolbar / page-header action buttons for the Chart of Accounts page.
 * Currently wraps the "New Account" button rendered inside PageHeaderWithBreadcrumbs.
 */


import { PageHeaderWithBreadcrumbs } from '@elsapiens/layout'
import { Button } from '@elsapiens/ui'
import { Link } from 'react-router-dom'

interface AccountActionsProps {
  onCreateAccount: () => void
  onSystemAccounts: () => void
}

export function AccountActions({ onCreateAccount, onSystemAccounts }: AccountActionsProps): JSX.Element {
  return (
    <PageHeaderWithBreadcrumbs
      description="Manage your organization's account structure"
      linkComponent={Link}
      title="Chart of Accounts"
      variant="card"
    >
      <Button variant="secondary" onClick={onSystemAccounts}>
        System Accounts
      </Button>
      <Button onClick={onCreateAccount}>
        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M12 4v16m8-8H4" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        </svg>
        New Account
      </Button>
    </PageHeaderWithBreadcrumbs>
  )
}
